// Shell-level "tab re-entered" signal.
//
// The tabs shell runs without `<ion-tab-bar>`, so when a route crosses INTO a
// tab from an OUTSIDE route (a lesson banner -> /tabs/library, a deep link,
// "back to home") Ionic can't identify the leaving tab: the previous route lived
// outside the tabs outlet, so `handlePageTransition` computes
// `leavingViewItem = null` and never re-fires the entering tab's
// `ionViewWillEnter`. A tab that loads its data in that lifecycle then renders
// stale or empty (this is what left the All page with no icons — issue #1487).
//
// `TabsPage` emits here once it has settled the active tab on shell entry (right
// after `hideStaleTabPages`); a tab subscribes via the `TabReentry` mixin and
// re-runs its own enter-fetch. That replaces the per-page `$route.path` watcher
// the All page used to carry, so every tab handles the gap the same way.

const listeners = new Set();

// Subscribe to shell re-entry. `listener` is called with the active tab's value
// (see `TAB_VALUES`). Returns an unsubscribe function.
export function addTabReenteredListener(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// Notify every subscriber that the shell was re-entered on `tabValue`.
export function emitTabReentered(tabValue) {
  // Snapshot first: a listener that unsubscribes itself must not perturb the
  // set mid-iteration.
  [...listeners].forEach(listener => {
    try {
      listener(tabValue);
    } catch (_) {
      // One misbehaving listener must not stop the rest.
    }
  });
}

// Test-only: clear all subscriptions so specs don't leak listeners into one
// another. Not used by the app.
export function _resetTabReenteredListeners() {
  listeners.clear();
}
